import { firstValueFrom, switchMap, take } from "rxjs";
import { api } from "../../common/api/index.ts";
import { LoginStatus } from "../../common/types.ts";
import { loginStatus$ } from "../store/loginV2.ts";
import { getTopics } from "./topics.ts";

const doUnpublishPresentation = api
	.path("/api/presentation/{presentationId}/pub")
	.method("delete")
	.create();

export function unpublishPresentation(presentationId: string) {
	return firstValueFrom(
		loginStatus$.pipe(
			take(1),
			switchMap((loginStatus) => {
				if (loginStatus.status !== LoginStatus.LOGGED_IN) {
					throw new Error("User is not logged in, cannot delete presentation");
				}
				return doUnpublishPresentation(
					{ presentationId },
					{
						headers: {
							authorization: `Bearer ${loginStatus.token}`,
						},
					},
				);
			}),
			switchMap(() => {
				return getTopics();
			}),
		),
	);
}
